import React from 'react'

import * as S from './styled'

type Props = {
  children: React.ReactNode
  info?: string
}

export const TagCell = ({ children, info }: Props) => (
  <div>
    <S.Name>{children}</S.Name>
    {info && <S.Info>{info}</S.Info>}
  </div>
)
